import { render, staticRenderFns } from "./skillsInput.vue?vue&type=template&id=ad66b0f4&scoped=true"
import script from "./skillsInput.vue?vue&type=script&lang=js"
export * from "./skillsInput.vue?vue&type=script&lang=js"
import style0 from "./skillsInput.vue?vue&type=style&index=0&id=ad66b0f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad66b0f4",
  null
  
)

export default component.exports